import { useState } from "react";

// import axios from 'axios'
import { useDispatch, useSelector } from "react-redux"
import marvarApi from "../../../../../../api/marvarApi"
import { onLogout } from "store"

import { useHelpers } from './useHelpers';
import { useGlobalStates } from './useGlobalStates';
import { useDefaultData } from './useDefaultData';
import { useForm } from './useForm';
import * as useFetchData from './useFetchData';
import { useActions } from './useActions';

export const useFechInitManagemenets = ({location, paramsURL}) => {

    const dispatch = useDispatch()

    const helpers = useHelpers()

    
    const { user } = useSelector((state) => state.auth)

    // globalStates -------------------------------------------------------------------------------
    const globalStates = useGlobalStates()

    // defaultData --------------------------------------------------------------------------------
    const defaultData = useDefaultData({helpers})

    // Para la modal -------------------------------------------------------
    const { defaultDataModal } = defaultData
    const [ dataModal, setDataModal ] = useState(defaultDataModal)
    const toggle = (_, title, compont, dataRequest) => {
        setDataModal({
            ...defaultDataModal,
            open: !dataModal.open,
            titleModal: title,
            componentModal: compont,
            dataRequest: dataRequest
        })
    }   

    const FormGlobal = useForm(defaultData.defaultFormGlobal)


    const Forms = {
        FormGlobal,
    }


    const defaultFetchParams = { 
        //------------- Generales
        marvarApi, user, dispatch, onLogout, location, paramsURL,
        //------------- globalStates
        // globalStates,
        //------------- defalutData
        defaultData, 
        //------------- Helpers
        helpers,
        //------------- Forms
        Forms 
    }



    const fetchAllManagements = useFetchData.useFetchAllManagements({...defaultFetchParams})
    const fetchInfoContract = useFetchData.useFetchInfoContract({...defaultFetchParams})

    const FetchData = {
        fetchAllManagements,
        fetchInfoContract
    }

    const Actions = useActions({
        marvarApi, toggle, user,
        FetchData,
        globalStates,
        defaultData,
        helpers,
        Forms,
    })

    return Object.freeze({
        //------------- Generales
        dataModal, toggle, user,
        globalStates,
        defaultData,
        FetchData,
        Forms,
        Actions
    })

}